import {
  SupportChatCategory,
  SupportChatPriority,
  SupportChatStatus,
} from "../../../common/enums";

export const supportChatCategoryLabels: Record<SupportChatCategory, string> = {
  [SupportChatCategory.General]: "Общо",
  [SupportChatCategory.Billing]: "Плащания",
  [SupportChatCategory.Technical]: "Технически въпрос",
  [SupportChatCategory.Other]: "Други",
  [SupportChatCategory.FeatureRequest]: "Заявка за функционалност",
  [SupportChatCategory.Bug]: "Проблем / бъг",
};

// Ordered list for display in dropdowns (excludes General)
export const supportChatCategoryOptions = [
  SupportChatCategory.Technical,
  SupportChatCategory.FeatureRequest,
  SupportChatCategory.Bug,
  SupportChatCategory.Billing,
  SupportChatCategory.Other,
];

export const supportChatPriorityLabels: Record<SupportChatPriority, string> = {
  [SupportChatPriority.Low]: "Нисък приоритет",
  [SupportChatPriority.Medium]: "Среден приоритет",
  [SupportChatPriority.High]: "Висок приоритет",
  [SupportChatPriority.Blocker]: "Блокер",
};

export interface ISupportChatListItem {
  id: string;
  title: string;
  category: SupportChatCategory;
  priority: SupportChatPriority;
  status: SupportChatStatus;
  createdOn: string;
  lastMessageAt: string | null;
  lastMessagePreview: string | null;
  hasUnread: boolean;
  createdByName: string;
}

export interface ISupportChatDetail {
  id: string;
  title: string;
  category: SupportChatCategory;
  priority: SupportChatPriority;
  status: SupportChatStatus;
  createdOn: string;
  createdByName: string;
  messages: ISupportMessage[];
}

export interface ISupportMessage {
  id: number;
  senderId: number;
  senderName: string;
  senderProfilePhotoUrl: string | null;
  content: string;
  sentAt: string;
  attachments: ISupportMessageAttachment[];
}

export interface ISupportMessageAttachment {
  id: number;
  fileName: string;
  url: string;
  contentType: string | null;
  fileSize: number;
}
